import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';

/**
 * libs
 */
import { OwlOptions } from 'ngx-owl-carousel-o';

/**
 * enums
 */
import { FEATURES_TYPE } from 'src/app/core/enums/features/features-type';
import { OTHER_DETAILS_TYPE } from 'src/app/core/enums/ads/other-details-types';

/**
 * interfaces
 */
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

@Component({
  selector: 'app-advertisement-details-slides',
  templateUrl: './advertisement-details-slides.component.html',
  styleUrls: ['./advertisement-details-slides.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvertisementDetailsSlidesComponent implements OnInit, OnChanges {

  /************  Inputs  ************/
  /**
   * data
   * @description Advertisement Data
   */
  @Input({ alias: 'data', required: true }) public AdvertisementData: IAdvertisementResponse = null;  

  /************  fields  ************/
  /**
   * OwlOptions
   * @description config for owl-carousel
   */
  public OwlCarousel: OwlOptions = {
    items: 3,
    rtl: true,
    margin: 24,
    loop: true,
    dots: false,
    autoWidth: true,
    responsive: {
      991: {
        loop: false
      },      
    }    
  }  

  /**
   * Tabs
   */
  public Tabs: {name: string, id: OTHER_DETAILS_TYPE, status: boolean}[] = []

  /**
   * CurrentTabActive
   */
  public CurrentTabActive: OTHER_DETAILS_TYPE = OTHER_DETAILS_TYPE.Properties;

  /**
   * ListOfDetails
   */
  public ListOfDetails: any[] = [] 

  /**
   * OTHER_DETAILS_TYPE
   */
  public get OTHER_DETAILS_TYPE(): typeof OTHER_DETAILS_TYPE {
    return OTHER_DETAILS_TYPE
  }

  /**
   * FEATURES_TYPE
   */
  public get FEATURES_TYPE(): typeof FEATURES_TYPE {
    return FEATURES_TYPE
  }


  /**
   *
   */
  constructor() {}
  
  /************  LifeCycleHooks  ************/
  /**
   * 
   * @param changes 
   */
  ngOnChanges(changes: SimpleChanges): void {

    // ES6 Destruction
    const { AdvertisementData : { currentValue, previousValue, firstChange }} = changes;

    /**
     * 
     */
    if (firstChange || currentValue?.id != previousValue?.id) {

      this.ChangeContentView(OTHER_DETAILS_TYPE.Properties);

    }


  }

  /**
   * 
   */
  ngOnInit(): void {

    /**
     * init
     */
    this.Tabs = [
      { 
        name: 'المواصفات',
        id: OTHER_DETAILS_TYPE.Properties,
        status: this._isLength(this.AdvertisementData?.properties),
      },
      { 
        name: 'المميزات',
        id: OTHER_DETAILS_TYPE.Features,
        status: this._isLength(this.AdvertisementData?.features),
      },
      { 
        name: 'التمويل' ,
        id: OTHER_DETAILS_TYPE.Financing,
        status: this._isLength(this.AdvertisementData?.banks),
      },
      { 
        name: 'ما بعد البيع',
        id: OTHER_DETAILS_TYPE.Services,
        status: this._isLength(this.AdvertisementData?.services),
      },
      { 
        name: 'التصاميم',
        id: OTHER_DETAILS_TYPE.Designs,
        status: this._isLength(this.AdvertisementData?.adsFile) || this._isLength(this.AdvertisementData?.sketch),
      }
    ];  

  }
  
  /************  Methods  ************/
  /**
   * 
   * @param value 
   */
  public ChangeContentView(value: OTHER_DETAILS_TYPE):void {

    // set new value
    this.CurrentTabActive = value;

    switch(value) {
      case OTHER_DETAILS_TYPE.Properties:
        this.ListOfDetails = this.AdvertisementData?.properties
        break;
      case OTHER_DETAILS_TYPE.Features:
        this.ListOfDetails = this.AdvertisementData?.features
        break;
      case OTHER_DETAILS_TYPE.Services:
        this.ListOfDetails = this.AdvertisementData?.services
        break;
      case OTHER_DETAILS_TYPE.Financing:
        this.ListOfDetails = this.AdvertisementData?.banks
        break;
      case OTHER_DETAILS_TYPE.Designs:
        if (Array.isArray(this.AdvertisementData?.adsFile)) {
          this.AdvertisementData.adsFile = this.AdvertisementData.adsFile.map(link => {
            return { name: 'ملف التصميم', link }
          }) as any
        }
        if (Array.isArray(this.AdvertisementData?.sketch)) {
          this.AdvertisementData.sketch = this.AdvertisementData.sketch.map(link => {
            return { name: 'ملف كيروكي العقار', link }
          }) as any
        }        
        this.ListOfDetails = [...this.AdvertisementData?.adsFile, ...this.AdvertisementData?.sketch]
        break;
    }
    
  }

  /**
   * _isLength
   * @description check if array has data
   */
  private _isLength(data: any[]): boolean {

    return Array.isArray(data) && data.length > 0

  }

}
